import React, { useState, useCallback, useEffect } from "react";
import { MasterTable } from "../../components/_index";
import { deleteCategory } from "../../services/category.service";
import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";
// import AddCategory from "./AddCategory";
import {
  getProjectDownloadTransaction,
  getProjectResponse,
  getProjectTransaction,
} from "../../services/transaction.service";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { ExcelReport } from "./ExcelExport";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const FeedbackReport = () => {
  const { RangePicker } = DatePicker;
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [tableTotalCount, setTableCount] = useState(0);
  const dispatch = useDispatch();
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
    status: "",
    startDate: dayjs().startOf("month").format("DD-MM-YYYY"),
    endDate: dayjs().endOf("month").format("DD-MM-YYYY"),
    statusList: [4, 2, 3],
  });
  const [queryParam2, setQueryParam2] = useState({
    startDate: dayjs().startOf("month").format("DD-MM-YYYY"),
    endDate: dayjs().endOf("month").format("DD-MM-YYYY"),
    statusList: [4, 2, 3],
  });

  const GetProjectTransactionData = async () => {
    try {
      const queryParams = { ...queryParam };

      if (Array.isArray(queryParams.statusList)) {
        queryParams.statusList = JSON.stringify(queryParams.statusList);
      }
      const res = await getProjectTransaction(queryParams);
      // console.log(res, "FRR");
      const modifiedData =
        res?.data.map((e) => ({
          ...e,
          personName: e?.name,
          sendAt: moment(e?.sendAt).format("DD/MM/YYYY"),
          projectShortName: e?.projectManagementInfo.projectShortName || "NA",
          typeChoosen:
            e?.status == 4
              ? "Proceed"
              : e?.status == 1
              ? "Send"
              : e?.status == 2
              ? "Skipped For Now"
              : "Never Ask Again",
          surveyInterval: `${e?.projectManagementInfo.surveyInterval}Month`,
          totalScore: ((e?.responseInfo?.totalScore / 100) * 10).toPrecision(2)  || "NA",
          // scaledScore: (e?.responseInfo?.totalScore / 100) * 10,

          // contactEmail: e?.contact[0].email,
        })) || [];
      setTableCount(res?.totalCount || 0);
      setData(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };
  const GetProjectTransactionData2 = async () => {
    try {
      const queryParams = { ...queryParam2 };

      if (Array.isArray(queryParams.statusList)) {
        queryParams.statusList = JSON.stringify(queryParams.statusList);
      }
      const res = await getProjectDownloadTransaction(queryParams);
      const modifiedData =
        res?.data.map((e) => ({
          ...e,
          personName: e?.name,
          sendAt: moment(e?.sendAt).format("DD/MM/YYYY"),
          projectShortName: e?.projectManagementInfo.projectShortName || "NA",
          typeChoosen:
            e?.status == 4
              ? "Proceed"
              : e?.status == 1
              ? "Send"
              : e?.status == 2
              ? "Skipped For Now"
              : "Never Ask Again",
          surveyInterval: `${e?.projectManagementInfo.surveyInterval}Month`,
          totalScore: ((e?.responseInfo?.totalScore / 100) * 10).toPrecision(2) || "NA",
          // scaledScore: (e?.responseInfo?.totalScore / 100) * 10,

          // contactEmail: e?.contact[0].email,
        })) || [];
      setTableCount(res?.totalCount || 0);
      setData2(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    // GetResponsiveFeedbackData();
    GetProjectTransactionData();
  }, [
    queryParam.search,
    queryParam.sort,
    queryParam.limit,
    queryParam.page,
    queryParam.startDate,
    queryParam.endDate,
  ]);
  useEffect(() => {
    GetProjectTransactionData2();
  }, [queryParam2.startDate, queryParam2.endDate]);

  const columns = [
    { id: "sendAt", label: "Email Send Date" },
    { id: "name", label: "Client Name" },
    { id: "projectShortName", label: "Project Short Name" },
    { id: "typeChoosen", label: "Type Choosen" },
    { id: "totalScore", label: "Total Score Taken" },
  ];

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedDataId, setSelectedDataId] = useState(null);

  const deleteFunction = async () => {
    try {
      const res = await deleteCategory(selectedDataId);
      console.log(res, "RRR");
      setConfirmDeleteOpen(false);
      //   GetCategoryData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      console.log(error);
    }
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const [multiDeleteId, setMultiDeleteId] = useState([]);

  const handleMultiSelect = (selectedIds) => {
    setMultiDeleteId(selectedIds);
  };

  const filteredData = data.filter((item) => multiDeleteId.includes(item._id));
  const finalData = filteredData.length > 0 ? filteredData : data2;

  return (
    <div className="mainContent">
      <Grid container mb={2}>
        <Grid size={{ xs: 12, sm: 3 }}>
          <Box className="SearchInputBoxContainer">
            <SearchOutlinedIcon className="Search_Icon" />
            <input
              className="SearchInputBox"
              placeholder="Search here"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Box>
        </Grid>
        {/* <Button onClick={handleDownload} className="addButton">
          Download Excel
        </Button> */}
        <Grid size={{ xs: 12, sm: 2, md: 4 }}></Grid>
        <Grid size={{ xs: 12, sm: 4, md: 3 }}>
          <Grid>
            <RangePicker
              value={[
                queryParam.startDate
                  ? dayjs(queryParam.startDate, "DD-MM-YYYY")
                  : null,
                queryParam.endDate
                  ? dayjs(queryParam.endDate, "DD-MM-YYYY")
                  : null,
                ,
              ]}
              onChange={(e) => {
                setQueryParam({
                  ...queryParam,
                  startDate: e?.[0] ? dayjs(e?.[0]).format("DD-MM-YYYY") : null,
                  endDate: e?.[1] ? dayjs(e?.[1]).format("DD-MM-YYYY") : null,
                });
                setQueryParam2({
                  ...queryParam,
                  startDate: e?.[0] ? dayjs(e?.[0]).format("DD-MM-YYYY") : null,
                  endDate: e?.[1] ? dayjs(e?.[1]).format("DD-MM-YYYY") : null,
                });
              }}
              style={{
                height: "38px",
              }}
            />
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, sm: 3, md: 2 }}>
          <Stack>
            <ExcelReport
              data={finalData}
              // data={data}
              // data={data.filter((item) => multiDeleteId.includes(item._id))}
              columns={[
                { header: "SI.No", key: "col1" },
                { header: "Client Name", key: "col2" },
                { header: "Project Short Name", key: "col3" },
                { header: "Email Send Date", key: "col4" },
                { header: "Type Chosen", key: "col5" },
                { header: "Total Score Taken", key: "col6" },
              ]}
              filename="Feedback_Report"
              customStyle={true}
            />
          </Stack>
        </Grid>
      </Grid>
      <MasterTable
        data={data}
        columns={columns}
        isServerSide={true}
        // handleView={handleView}
        // handleEdit={handleEdit}
        // handleDelete={handleDelete}
        handleMultiSelect={handleMultiSelect}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
      />

      <ConfirmBox
        open={confirmDeleteOpen}
        title="Are you sure you want to delete?"
        content={`You are about to delete this item`}
        confirmButton={"Delete"}
        setOpenConfirmBox={() => setConfirmDeleteOpen(false)}
        Function={deleteFunction}
      />
    </div>
  );
};

export default FeedbackReport;
